module.exports = __webpack_public_path__ + "img/SeebrückeSeelin.d620f121.svg";